import { Helmet } from 'react-helmet-async';
import { Box, Button, Stack, Typography, styled } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { accountPath } from '@lingoda/router';
import NotFoundIllustration from '../components/assets/not-found.svg?component';

const NotFoundPage = () => (
    <>
        <Helmet>
            <title>{trans('page-not-found-title-', {}, 'public-meta')}</title>
            <meta name="robots" content="noindex" />
            <meta name="googlebot" content="noindex" />
            <meta name="description" content={trans('main-description', {}, 'public-meta')} />
            <meta name="keywords" content={trans('main-keywords-', {}, 'public-meta')} />
        </Helmet>
        <Wrapper>
            <Stack sx={{ gap: 6, alignItems: 'center' }}>
                <NotFoundIllustration />
                <Stack spacing={1} sx={{ alignItems: 'center', textAlign: 'center' }}>
                    <Typography variant="h1">
                        {trans('not-found-title', {}, 'public-common')}
                    </Typography>
                    <Typography variant="body1" htmlColor="text.secondary">
                        {trans('not-found-subtitle', {}, 'public-common')}
                    </Typography>
                </Stack>
                <Button color="primary" variant="contained" href={accountPath()}>
                    {trans('not-found-cta', {}, 'public-common')}
                </Button>
            </Stack>
        </Wrapper>
    </>
);

const Wrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3),
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1),
    },
}));

export default NotFoundPage;
